import { Autocomplete, Checkbox, TextField, Typography } from "@mui/material"
import { red } from "@mui/material/colors"
import { Fragment } from "react"

function SpecializationAreas({ areas, errors, errText, label, onChangFun, persistedData, files, specialist }) {

  const getDefaultValue = () => {
    if (files?.current?.specializationArea?.length) {
      return files.current.specializationArea
    }
    if (specialist?.profile?.specializationArea?.length) {
      return specialist.profile.specializationArea
    }
    return []
  }

  return (
    <Fragment>
      <Typography
        sx={{
          mb: 1,
          fontSize: "16px",
          fontWeight: "600",
          color: "other.color1",
        }}
      >{label}
      </Typography>
      <Autocomplete
        multiple
        size="small"
        variant="custom"
        options={areas}
        onChange={onChangFun || null}
        defaultValue={getDefaultValue()}
        key={JSON.stringify(getDefaultValue())} 
        getOptionKey={(option) => option?._id}
        getOptionLabel={(option) => option?.name}
        isOptionEqualToValue={(option, value) => option?._id === value?._id}
        renderInput={(props) => <TextField placeholder="Select Item" {...props} />}
        renderOption={(props, option, { selected }) => {
          const { key, ...optionProps } = props;
          return (
            <li key={key} {...optionProps}>
              <Checkbox
                sx={{
                  p: "0",
                  ".MuiSvgIcon-root": { height: "20px" }
                }}
                checked={selected}
                style={{ marginRight: 8 }}
              />
              {option.name}
            </li>
          )
        }}
      />
      {errors?.specializationArea &&
        <Typography
          mt={1}
          color={red["500"]}
        >{errText || "Please select areas of specialization"}
        </Typography>
      }
    </Fragment>
  )
}

export default SpecializationAreas